<template>
  <v-card>
    <Cabecera 
      v-if="!incrustado" 
      tipoModuloActual="contrato"
      :incrustado="incrustado"/>
    <StepperPortal v-if="!incrustado" tipoModuloActual="contrato" />
    <v-container fluid>
      <o-big-title v-if="incrustado">{{titulo}}</o-big-title>
      <o-base-justify-text>
        <v-layout column>
            <template v-if="!firmando">
              <span v-if="reserva.cod_tipo_operacion == 'VTA'" v-html="reserva.estadoKyc.codigoEstadoKyc === 10 ? getTexto('contrato.bienvenidaYaRellenado', reserva.codigoPromocion) : getTexto('contrato.bienvenida', reserva.codigoPromocion)"/>
              <span v-else v-html="reserva.estadoKyc.codigoEstadoKyc === 10 ? getTexto('contrato.bienvenidaAlquilerYaRellenado', reserva.codigoPromocion) : getTexto('contrato.bienvenidaAlquiler', reserva.codigoPromocion)"/>
              <br/>
            </template>
            <span v-if="incrustado">
              {{$t('reservas.contrato.incrustadoTexto')}}
            </span>
        </v-layout>
      </o-base-justify-text>
      <div class="mb-3"  v-if="firmando && !firmaTerminada && reserva.contrato.tipoFirma == 'L' && reserva.contrato.url != null">
        <div class="signaturit-div">
          <iframe class="signaturit-iframe" :src="reserva.contrato.url"/>
        </div>
        <v-layout v-if="reserva.contrato.otp" class="red--text text--darken-2">
          {{$t('reservas.contrato.avisoOtp')}}
        </v-layout>
      </div>
      <div class="mb-3"  v-if="firmando && !firmaTerminada && reserva.contrato.tipoFirma == 'D'">
        <ContratoMostrarFirmantesEmail
          :contratoId="reserva.contrato.id"
        />
      </div>
      <o-main-progress class="elevation-0" :texto="$t('reservas.contrato.comprobandoFirma')" v-else-if="!loadedAll || (firmando && firmaTerminada)"/>
      <div v-if="!firmando && loadedAll">
        <o-base-text v-if="!reserva.estadoKyc.codigoEstadoKyc === 10">
          {{$t('reservas.contrato.declareCompradores', {tipo: reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.contrato.compradores') : $t('reservas.contrato.arrendatarios')})}}
        </o-base-text>
        <v-form ref="form" v-model="valid">
          <BaseKyc
            :compradores.sync="compradores"
            :expansion.sync="expansion"
            :incrustado="incrustado"
            :cargandoExterior="cargandoExterior"
            :waitingForLoad="waitingForLoad"
            :mostrarDescripcion="true"
            :guardarYEnviar="guardarYEnviar"
            :tipo="'contrato'"
          />
        </v-form>
        <!-- Botonera -->
        <v-layout justify-space-between align-center>
          <v-flex xs2>
            <v-btn
              flat
              class="titleColor--text ml-0 pl-0"
              :disabled="waitingForLoad  || cargandoExterior"
              @click="$router.push({
                name: 'reservas.id',
                params: {id: reserva.id}
              })"
              v-if="!incrustado"
              :icon="$vuetify.breakpoint.xsOnly"
            >
              <!-- eslint-disable-next-line -->
              <v-icon class="mr-1">{{$vuetify.breakpoint.xsOnly ? 'arrow_back':'chevron_left'}}</v-icon>
              <span class="hidden-xs-only">{{$t('reservas.condiciones.volver')}}</span>
            </v-btn>
          </v-flex>
          <v-layout 
            v-if="!contratoVer"
            :column="$vuetify.breakpoint.smAndDown" 
            :shrink="$vuetify.breakpoint.smAndDown" 
            justify-space-around
          >
            <v-btn
              v-if="!incrustado && this.reserva.estadoKyc.codigoEstadoKyc !== 10" 
              large
              color="primary"
              :disabled="waitingForLoad || cargandoExterior"
              :loading="waitingForLoad || cargandoExterior"
              @click="aceptar(false)"
            >
              {{$t('reservas.contrato.continuarMasTarde')}}
            </v-btn>
            <v-btn
              large
              color="primary"
              :disabled="waitingForLoad || cargandoExterior"
              :loading="waitingForLoad || cargandoExterior"
              @click="aceptar(true)"
            >
              {{incrustado ? $t('reservas.contrato.continuar') : $t('reservas.contrato.aceptar')}}
            </v-btn>
          </v-layout>
          <v-flex xs2/>
        </v-layout>
      </div>
      <v-fade-transition>
        <custom-dialog 
          v-if="!incrustado && (esAdministrador || esComercial) && mostrarPopUpFirmantes" 
          v-model="mostrarPopUpFirmantes"
          :cambiado="cambiadoFirma"
          @aceptar="mostrarPopUpFirmantes = false"
        >
          <ContratoElegirFirmantes
            :representantes.sync="representantes"
            :plantilla.sync="plantilla"
            :otp.sync="otp"
            :tipo.sync="tipo"
            @cambiado="cambiadoFirma = $event"
            @aceptar="aceptar(true,true, true)"
          />
        </custom-dialog>
      </v-fade-transition>
      <v-fade-transition>
        <custom-dialog v-if="mostrarTerminado" v-model="mostrarTerminado" :noCerrar="true">
          <ContratoTerminar
            :cargandoExterior="cargandoExterior"
            :incrustado="incrustado"
            @continuar="terminar(false)"
          />
        </custom-dialog>
      </v-fade-transition> 
      <v-fade-transition>
        <custom-dialog v-if="mostrarErrorFirma" v-model="mostrarErrorFirma" :noCerrar="true">
          <DocumentacionErrorContrato 
            :cargandoExterior="cargandoExterior"
            :incrustado="incrustado"
            @continuar="cerrarPopUpErrorFirma()"
          />
        </custom-dialog>
      </v-fade-transition>
      <v-fade-transition>
        <custom-dialog v-if="mostrarInicidencias" v-model="mostrarInicidencias" :noCerrar="true">
          <ContratoMostrarIncidencias 
            :pdf="documentoIncidencias"
            :incidencias="incidencias"
          />
        </custom-dialog>
      </v-fade-transition>
      <v-fade-transition>
        <custom-dialog v-if="mostrarComprobarEmail" v-model="mostrarComprobarEmail">
          <ComprobarEmailTelefono
            :compradores="compradores"
            @aceptar="cambiarEmailTelefono"
          />
        </custom-dialog>
      </v-fade-transition>
    </v-container>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseKyc from '@/components/reservas/comprador/BaseKyc'
import ComprobarEmailTelefono from '@/components/reservas/comprador/ComprobarEmailTelefono'
import ContratoElegirFirmantes from '@/components/reservas/contratos/ContratoElegirFirmantes'
import ContratoMostrarFirmantesEmail from '@/components/reservas/contratos/ContratoMostrarFirmantesEmail'
import ContratoMostrarIncidencias from '@/components/reservas/contratos/ContratoMostrarIncidencias'
import MixinComprador from '@/mixins/comprador'
import MixinEstadoContrato from '@/mixins/estadosReserva/estadoContrato'
import rules from '@/mixins/rules'
import ContratoTerminar from './ContratoTerminar'
import Cabecera from '@/components/Cabecera'
import _ from 'lodash'
import DocumentacionErrorContrato from '@/components/reservas/documentacion/DocumentacionErrorContrato'
import StepperPortal from '@/components/StepperPortal'

export default {
  mixins: [rules, MixinComprador, MixinEstadoContrato],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    actual: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      compradoresCreated: false,
      disabled: false,
      waitingForLoad: false,
      loadedAll: false,
      compradores: [],
      representantes: [],
      plantilla: null,
      otp: false,
      tipo: 'url',
      expansion: [],
      valid: false,
      numeroFirmas: 0,
      firmando: false,
      firmaTerminada: false,
      guardarYEnviar: false,
      mostrarPopUpFirmantes: false,
      cambiadoFirma: false,
      cambiadoCompradores: false,
      mostrarTerminado: false,
      mostrarErrorFirma: false,
      incidencias: [],
      documentoIncidencias: null,
      mostrarInicidencias: false,
      mostrarComprobarEmail: false
    }
  },
  components: {
    BaseKyc,
    ContratoElegirFirmantes,
    ContratoMostrarFirmantesEmail,
    ContratoTerminar,
    Cabecera,
    DocumentacionErrorContrato,
    StepperPortal,
    ContratoMostrarIncidencias,
    ComprobarEmailTelefono
  },
  mounted () {
    window.addEventListener('message', this.completedEvent)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.completedEvent)
  },
  async created () {
    this.inicializarCompradores()
    this.representantes = this.getAllRepresentantes.filter(x => x.esPorDefecto)
    let checkPlantilla = this.getPromocionPlantillas.filter(x => x.ambito === this.reserva.cod_tipo_operacion).find(x => x.esPorDefecto)
    if (checkPlantilla == null) {
      this.plantilla = null
    } else {
      this.plantilla = checkPlantilla.plantilla.id
    }
    this.otp = this.otpActivado
    this.tipo = this.representantes.some(x => x.representante.documento_id == null) ? 'email' : 'url'
    try {
      if (this.reserva.estadoContrato.codigoEstadoContrato === 3) {
        if (this.reserva.contrato.estado.codigo === 10) {
          // Si ya se firmo llamar a terminar y poner alert
          await this.firmarContrato(this.reserva.id)
          this.addAlert({texto: this.$t('reservas.contrato.contratoFirmado'), color: 'success'})
          this.terminar(true)
        } else if (this.reserva.contrato.estado.codigo === 1 || this.reserva.contrato.estado.codigo === 5) {
          this.numeroFirmas = this.reserva.contrato.firmantes.filter(f => f.estado.codigo === 10).length
          this.firmando = true
        } else if (this.reserva.contrato.estado.codigo === 90) { // Cancelado
          this.addAlert({texto: this.$t('reservas.contrato.firmaRechazado'), color: 'error'})
          this.$emit('error')
        } else { // Anulado o similar
          this.addAlert({texto: this.$t('reservas.contrato.huboError'), color: 'error'})
          this.$emit('error')
        }
      }
      this.loadedAll = true
    } catch (error) {
      this.loadedAll = true
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
      this.$emit('error')
    }
    this.$nextTick(() => {
      this.compradoresCreated = true
    })
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      modulos: 'modulosOrdenes/modulos/getAll',
      getAllRepresentantes: 'promocionesRepresentantes/getAll',
      getPromocionPlantillas: 'promocionesPlantillas/getAll',
      getVariableConfiguracion: 'configuracion/variablesConfiguracion/getById'
    }),
    titulo () {
      return this.getTexto('modulos.contrato' + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
    },
    otpActivado () {
      return this.getVariableConfiguracion('VD_OTP_ACTIVADO') && this.getVariableConfiguracion('VD_OTP_ACTIVADO').valor === 'S'
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      modificarCompradoresContrato: 'contratos/modificar',
      firmarContrato: 'contratos/firmar'
    }),
    terminar (terminar = true) {
      this.$emit('cambiado', false)
      this.$emit('terminado', terminar)
    },
    cerrarPopUpErrorFirma () {
      if (this.incrustado) {
        this.terminar(false)
      } else {
        this.$emit('error')
      }
    },
    cambiarEmailTelefono (compradores) {
      for(let i = 0; i < compradores.length; i++) {
        this.compradores[i].email = compradores[i].email
        this.compradores[i].numTelefono = compradores[i].numTelefono
        this.compradores[i].telefono = compradores[i].telefono
        this.compradores[i].codigoPrefijoTelefonicoId = compradores[i].codigoPrefijoTelefonicoId
      }
      this.mostrarComprobarEmail = false
      this.aceptar(true, true, false)
    },
    // eslint-disable-next-line
    async aceptar (completado, comprobado = false, vengoDePopUp = false) {
      this.guardarYEnviar = completado
      if (completado) {
        this.$refs.form.validate()
        await this.$nextTick() // Si no lo pongo parece que el valid está tardando un frame en cargarse
        if (!this.valid) {
          this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
          return
        }
        let suma = 0
        for (let i = 0; i < this.compradores.length; i++) {
          suma += Number(this.compradores[i].porcentajeParticipacion)
        }
        if (suma < 99.9 || suma > 100.1) {
          this.addAlert({texto: this.$t('reservas.contrato.avisoPorcentaje'), color: 'error'})
          return
        }
        this.cambiadoFirma = false
        if (!comprobado) {
          this.mostrarComprobarEmail = true
          return
        }
        if (!vengoDePopUp && !this.incrustado && (this.esComercial || this.esAdministrador)) {
          this.mostrarPopUpFirmantes = true
          return
        } else {
          this.mostrarPopUpFirmantes = false
        }
      }
      try {
        this.waitingForLoad = true
        await this.modificarCompradoresContrato({
          id: this.reserva.id,
          compradores: _.concat(this.compradores.filter(x => x.id == null), _.concat(_.uniqBy(this.compradores.filter(x => x.id != null), 'id'))),
          completado: completado,
          representantes: this.representantes.map(x => ({id: x.id, tipoDocumento: x.representante.tipoDocumento, numeroDocumento: x.representante.numeroDocumento})),
          plantilla: this.plantilla,
          otp: this.otp,
          tipo: this.tipo
        })
        if (completado) {
          // Cambiar a contrato
          this.firmando = true
          if (this.reserva.contrato.tipoFirma == 'D') { // firma por correo
            this.mostrarTerminado = true
          } else {
            this.mostrarTerminado = false
          }
        } else {
          this.terminar(false)
        }
        this.waitingForLoad = false
        this.guardarYEnviar = true
        return true
      } catch (error) {
        this.waitingForLoad = false
        this.guardarYEnviar = true
        if (!error.code || (error.code !== 1 && error.code !== 21)) {
          this.addAlert({texto: error.message, color: 'error'})
        } else if (error.code === 21) {
          if (this.esComercial || this.esAdministrador) {
            // Mostrar popup incidencias con documento
            this.incidencias = error.incidences
            this.documentoIncidencias = error.data.data.pdf
            this.mostrarInicidencias = true
          } else {
            this.addAlert({texto: error.message, color: 'error'})
          }
          
        }
      }
    },
    async completedEvent (e) {
      try {
        if (e.data.event === 'completed' && this.actual) {
          this.numeroFirmas = this.reserva.contrato.firmantes.length
          if (this.numeroFirmas === this.reserva.contrato.firmantes.length) {
            this.firmaTerminada = true
            await this.firmarContrato({id:this.reserva.id, simplificada: false})
            this.terminar(true)
          }
        }
      } catch (error) {
        console.log(error)
        if (error.code && Number(error.code) === 16) { // PETO LA FIRMA
          this.mostrarErrorFirma = true
        } else {
          this.addAlert({texto: error.message, color: 'error'})
          this.$emit('error')
        }
      }
    }
  },
  watch: {
    compradores: {
      deep: true,
      handler () {
        this.cambiadoCompradores = this.compradoresCreated
        this.$emit('cambiado', this.compradoresCreated || this.cambiadoFirma)
      }
    },
    cambiadoFirma (val) {
      this.$emit('cambiado', val || this.compradoresCreated)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/contratos/Contrato.vue